import strings from '../../../Localization/Localization';

let name = {
  fieldKey: "name",
  type: "text",
  label: strings.form.appointmentType.name.label,
  showOnDisabled: () => false,
  validators: []
}

export const form = {
  formKey: "appointmentTypeSearch",
  fields: [
    name
  ]
}
